import { SxProps, Theme } from "@mui/material";

// Common style objects for OverlayVsStockChart
export const overlayVsStockChartStyles = {
  // Card container styles
  card: {
    padding: 2,
    cursor: "pointer",
    backgroundColor: "white",
    borderRadius: 2,
    border: "1px solid #E0E0E0",
    "&:hover": {
      boxShadow: 4,
    },
  } as SxProps<Theme>,

  // Title styles
  title: {
    color: "#2C8BB0",
    marginBottom: 2,
    fontWeight: 500,
    fontSize: "1.25rem",
    fontFamily: '"Poppins", sans-serif',
  } as SxProps<Theme>,

  // Title illustrative text styles
  titleIllustrative: {
    color: "#2C8BB0",
    fontWeight: 400,
    fontSize: "0.9em",
  } as SxProps<Theme>,

  // Bars container styles
  barsContainer: {
    marginBottom: 3,
  } as SxProps<Theme>,

  // Bar row container styles
  barRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: 1.5,
  } as SxProps<Theme>,

  // Bar label styles
  barLabel: {
    minWidth: 150,
    color: "#003057",
    fontSize: "0.875rem",
    fontFamily: '"Poppins", sans-serif',
  } as SxProps<Theme>,

  // Bar container styles (unfilled background)
  barContainer: {
    flex: 1,
    height: 32,
    backgroundColor: "#E0F2F7",
    borderRadius: 1,
    position: "relative",
    overflow: "hidden",
    marginRight: 2,
  } as SxProps<Theme>,

  // Bar filled portion styles
  barStockOnlyFilled: {
    position: "absolute",
    left: 0,
    top: 0,
    height: "100%",
    backgroundColor: "primary.main",
    transition: "width 0.3s ease",
  } as SxProps<Theme>,

  barStockOverlayFilled: {
    position: "absolute",
    left: 0,
    top: 0,
    height: "100%",
    backgroundColor: "#003057",
    transition: "width 0.3s ease",
  } as SxProps<Theme>,

  // Bar value styles
  barValue: {
    color: "#2C8BB0",
    fontWeight: 500,
    minWidth: 60,
    textAlign: "right",
    fontSize: "0.875rem",
    fontFamily: '"Poppins", sans-serif',
  } as SxProps<Theme>,
};

// Modal styles
export const overlayVsStockEditModalStyles = {
  // Modal container styles
  modalContainer: {
    width: "500px",
  } as SxProps<Theme>,

  // Form buttons container styles
  buttonsContainer: {
    display: "flex",
    gap: 1,
    margin: 1,
  } as SxProps<Theme>,

  // Button styles
  button: {
    flex: 1,
  } as SxProps<Theme>,
};
